export default __webpack_public_path__ + "static/media/volume.197dc8a5.svg";